import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';

export class ModalsSDKShape extends BaseSDKShape {
  async openDashboardModal(options: {
    url: string;
    closeOtherPanels?: boolean;
  }) {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.panels.openDashboardPanel(
      await this.getAppDefinitionId(),
      options,
    );
  }
}

export default new PlatformSDKShape(ModalsSDKShape)
  .withPublicMethod('openDashboardModal')
  .build();
